// src/pages/Sale/Sale.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import './sale.css';

// Images
import groceryImg from "../../../assets/groceries.jpg";
import fruitsImg from "../../../assets/fruitandveg.jpg";
import appliancesImg from "../../../assets/homeappliances.jpg";
import bagsImg from "../../../assets/bagsandlugage.jpg";

// Optional banners
import bannerImg from "../../../assets/banner.jpg";
import dealsImg from "../../../assets/deals.jpg";
import bestImg from "../../../assets/best.jpg";

export default function Sale() {
  const navigate = useNavigate();

  const categories = [
    { name: "Grocery", img: groceryImg, path: "/grocery" },
    { name: "Fruits & Vegetables", img: fruitsImg, path: "/fruits" },
    { name: "Home Appliances", img: appliancesImg, path: "/homeappliances" },
    { name: "Bags & Luggages", img: bagsImg, path: "/bags" },
  ];

  // WhatsApp link
  const whatsappLink = "https://wa.me/971542660433";

  return (
    <div className="home-container">

      {/* Categories Section */}
      <div className="categories">
        {categories.map((cat, index) => (
          <div
            className="category-card"
            key={index}
            onClick={() => cat.path && navigate(cat.path)}
            style={{ cursor: cat.path ? "pointer" : "default" }}
          >
            <img src={cat.img} alt={cat.name} />
            <div className="category-overlay">
              <p>{cat.name}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Banner Section */}
      <div className="banner-section">

        {/* Main Banner */}
        <div className="main-banner">
          <img src={bannerImg} alt="Banner" />
          <div className="banner-text">
            <h2>
              Your <span>Everyday</span><br />
              Essentials at the <br />
              <strong>Best Prices!</strong>
            </h2>
            <a 
              href={whatsappLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="shop-now-btn"
            >
              Enquire Now
            </a>
          </div>
        </div>

        {/* Side Banners */}
        <div className="side-banners">

          <div 
            className="small-banner"
            onClick={() => navigate("/offer")}
            style={{ cursor: "pointer" }}
          >
            <img src={dealsImg} alt="Deals" />
            <div className="small-banner-text">
              <p>Discover Our <strong>Latest Deals</strong></p>
            </div>
          </div>

          <div 
            className="small-banner"
            onClick={() => navigate("/shop")}
            style={{ cursor: "pointer" }}
          >
            <img src={bestImg} alt="Best" />
            <div className="small-banner-text">
              <p>Explore <strong>Best Selling Products</strong></p>
            </div>
          </div>

        </div>

      </div>

    </div>
  );
}